import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';

import * as AuthUtils from 'utils/auth';
import * as Config from 'utils/config';

const UNAUTHENTICATED_ROUTES = [{ method: 'post', path: '/login' }];

const gatewayClient = axios.create({
  baseURL: process.env.REACT_APP_GATEWAY_BASE_URL,
  timeout: 60000 * 5, //5 min
  headers: {
    'Content-Type': 'application/json',
  },
});

const isPublicUrl = ({ method, path }: $TSFixMe) =>
  UNAUTHENTICATED_ROUTES.some(
    (route) => method === route.method && path === route.path
  );

const request_middleware = (config: $TSFixMe) => {
  if (isPublicUrl({ method: config.method, path: config.url })) {
    return config;
  }

  const token = AuthUtils.getAuthCookie();
  const employee_id = AuthUtils.getEmployeeIdCookie();
  const csrf_token = AuthUtils.getCSRFToken();

  const current_page = window.location.pathname;

  return {
    ...cloneDeep(config),
    headers: {
      ...config.headers,
      'x-auth-token': token,
      'x-csrf-token': csrf_token,
      'x-trace-id': `twicapp-client=${employee_id}=${current_page}=${new Date().valueOf()}`,
    },
  };
};

const errorHandler = (error: $TSFixMe) => {
  if (error.response && error.response.status === 401) {
    AuthUtils.removeAuthCookie();
    AuthUtils.removeEmployeeIdCookie();
    const redirectUrl = error?.response?.data?.message
      ? `${Config.getLogInRedirectUrl()}?message=${error.response.data.message}`
      : Config.getLogInRedirectUrl();
    window.location.href = redirectUrl;
    return;
  }
  if (error.response && error.response.status === 403) {
    return Promise.reject(error);
  }

  return Promise.reject(error);
};

gatewayClient.interceptors.request.use(request_middleware, (error) =>
  Promise.reject(error)
);

gatewayClient.interceptors.response.use(
  (response) => response.data,
  errorHandler
);

export { gatewayClient };
